var React = require('react');

function LogoSingle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.5038 31.1203C32.8482 31.1203 35.5601 34.044 35.5601 37.6502C35.5601 41.2563 32.8482 44.18 29.5038 44.18C26.1589 44.18 23.4474 41.2563 23.4474 37.6502C23.4474 34.044 26.1589 31.1203 29.5038 31.1203Z","fill":"#ED1C24","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.42346 52H16.9412L29.4326 17.857L41.9528 52H49.4416L29.5556 0.960499L9.42346 52Z","fill":"white","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 22.0153C13.5952 8.863 46.2218 38.7543 64.2299 24.6511C42.5632 45.9356 21.8704 15.78 0 22.0153Z","fill":"#ED1C24","key":2})]);
}

LogoSingle.defaultProps = {"width":"65","height":"52","viewBox":"0 0 65 52","fill":"none"};

module.exports = LogoSingle;

LogoSingle.default = LogoSingle;
